module.exports = __webpack_public_path__ + "img/Defi_dis.8090ff66.png";